import { Divider, Grid, Skeleton } from '@mui/material'
import React from 'react'
import styles from "../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import globalStyles from "../../../../../assets/styles/global.module.scss";
import clsx from "clsx";

// Matches the number of label/value rows InfoTabContent renders for a typical
// thread (Source, Business Name, Chatbot Phone Number, User Name, User Phone
// Number, Last activity at).
const INFO_ROW_COUNT = 5;

// Ticket History, Tags, Notes cards rendered below the divider in InfoTabContent.
// const INFO_CARD_TITLE_WIDTHS = ['40%', '20%', '25%'];
const INFO_CARD_TITLE_WIDTHS = [110, 50, 60];

const InfoRowSkeleton: React.FC = () => (
    <Grid item mt={1} className={clsx(styles.userLastMessageEntries, globalStyles.maxWidthFull, globalStyles.overflowHidden)}>
        <Grid container direction={"column"}>
            <Grid item className={styles.messageEntryTitle}>
                <Skeleton variant="text" width="50%" height={18} />
            </Grid>
            <Grid item className={styles.messageEntryValue}>
                <Skeleton variant="text" width="70%" height={20} />
            </Grid>
        </Grid>
    </Grid>
);

const InfoCardSkeleton: React.FC<{ titleWidth: number }> = ({ titleWidth }) => (
    <Grid item mt={2} ml={0.2} mr={0.2} className={clsx(globalStyles.maxWidthFull, globalStyles.overflowHidden)}>
        <Grid container direction={"column"} gap={"8px"}>
            <Grid item className={globalStyles.fullwidth}>
                <Grid container justifyContent={"space-between"} alignItems={"center"} sx={{ flexWrap: 'nowrap' }}>
                    <Grid item>
                        <Skeleton variant="text" width={titleWidth} height={22} />
                    </Grid>
                    <Grid item>
                        <Skeleton variant="rounded" width={55} height={18} />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item className={styles.messageEntryValue}>
                <Skeleton variant="text" width={"65%"} height={18} />
            </Grid>
        </Grid>
    </Grid>
);

/**
 * Skeleton loader for the Info tab (ChatInformationBlock > InfoPanel > InfoTabContent).
 * Shown while isInfoTabLoading is true in ruleBasedInboxStore.
 */
const InfoTabSkeleton: React.FC = () => {
    const innerHeight = window.innerHeight - 200;

    return (
        <Grid item className={`${globalStyles.overflowAuto} ${globalStyles.fullwidth}`} sx={{ height: `${innerHeight}px`, maxHeight: `${innerHeight}px`, overflowX: 'hidden' }}>
            <Grid container direction={"column"}>
                {Array.from({ length: INFO_ROW_COUNT }).map((_, index) => (
                    <InfoRowSkeleton key={index} />
                ))}

                <Grid item mt={2}>
                    <Grid container direction={"column"}>
                        <Grid item>
                            <Divider />
                        </Grid>
                        {INFO_CARD_TITLE_WIDTHS.map((titleWidth, index) => (
                            <InfoCardSkeleton key={index} titleWidth={titleWidth} />
                        ))}
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default React.memo(InfoTabSkeleton);
